/**
 * 選考管理機能の表示名
 */
export const ENTRY_MANAGEMENT_FEATURE_NAME = '就活コパイロット' as const;

export const ENTRY_MANAGEMENT_TITLE_DASHBOARD =
  `ダッシュボード - ${ENTRY_MANAGEMENT_FEATURE_NAME}` as const;
export const ENTRY_MANAGEMENT_DESCRIPTION_DASHBOARD =
  'あなたの選考管理をサポートする就活コパイロットのダッシュボードです。進行中の選考状況やToDo、カレンダーを一目で確認できます。' as const;

export const ENTRY_MANAGEMENT_TITLE_PROGRESS =
  `選考管理 - ${ENTRY_MANAGEMENT_FEATURE_NAME}` as const;
export const ENTRY_MANAGEMENT_DESCRIPTION_PROGRESS =
  'あなたの選考管理をサポートする就活コパイロットの選考管理ページです。各企業の選考状況を詳細に把握し、効率的に就活を進めましょう。' as const;

export const ENTRY_MANAGEMENT_TITLE_TODO =
  `ToDo - ${ENTRY_MANAGEMENT_FEATURE_NAME}` as const;
export const ENTRY_MANAGEMENT_DESCRIPTION_TODO =
  'あなたの選考管理をサポートする就活コパイロットのToDoページです。選考に関連するタスクを整理し、効率的に就活を進めましょう。' as const;

export const ENTRY_MANAGEMENT_TITLE_CALENDAR =
  `カレンダー - ${ENTRY_MANAGEMENT_FEATURE_NAME}` as const;
export const ENTRY_MANAGEMENT_DESCRIPTION_CALENDAR =
  'あなたの選考管理をサポートする就活コパイロットのカレンダーページです。選考スケジュールを一元管理し、重要な日程を見逃さずに就活を進めましょう。' as const;
